import { render, staticRenderFns } from "./ResourceDetailsComponent.vue?vue&type=template&id=3adb03aa&scoped=true&"
import script from "./ResourceDetailsComponent.vue?vue&type=script&lang=ts&"
export * from "./ResourceDetailsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceDetailsComponent.vue?vue&type=style&index=0&id=3adb03aa&scoped=true&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3adb03aa",
  null
  
)

export default component.exports